<template>
  <b-form-input
    :value="formattedValue"
    :placeholder="placeholder"
    @input="formatValue"
    :title="title"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formattedValue: this.formatCurrency(this.value)
    };
  },
  watch: {
    value(newValue) {
      this.formattedValue = this.formatCurrency(newValue);
    }
  },
  methods: {
    formatCurrency(value) {
      console.log('Valor original:', value);

      if (!value) return '0,00';

      const digits = value.toString().replace(/\D/g, ''); // Remove não numéricos
      console.log('Dígitos extraídos:', digits);

      const numeric = digits.replace(/^0+/, '') || '0'; // Remove zeros à esquerda, mas preserva o zero final
      console.log('Valor numérico sem zeros à esquerda:', numeric);

      // Divide os números em parte inteira e parte decimal
      const integerPart = numeric.slice(0, -2); // Parte inteira (deixa os últimos dois dígitos para os decimais)
      const decimalPart = numeric.slice(-2); // Parte decimal (dois últimos dígitos)

      // Formatação da parte inteira com separador de milhar
      const integerFormatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      console.log('Parte inteira formatada:', integerFormatted);

      // Junta a parte inteira e decimal
      const formatted = integerFormatted + ',' + decimalPart;
      console.log('Valor formatado:', formatted);

      return formatted;
    },

    formatValue(event) {
      let inputValue = event.target.value;
      console.log('Valor de entrada:', inputValue);

      // Remove pontos e substitui vírgula por marcador para facilitar
      inputValue = inputValue.replace(/\./g, '').replace(',', '#');
      console.log('Após remoção de pontos e substituição de vírgula:', inputValue);

      // Remove todos os caracteres não numéricos
      inputValue = inputValue.replace(/\D/g, '');
      console.log('Após remoção de caracteres não numéricos:', inputValue);

      // Restaura a vírgula
      inputValue = inputValue.replace('#', ',');
      console.log('Após restauração da vírgula:', inputValue);

      // Separa a parte inteira da decimal
      const [inteiroRaw, decimalRaw] = inputValue.split(',');
      const inteiro = inteiroRaw || '0'; // Parte inteira
      const decimal = (decimalRaw || '').slice(0, 2); // Limita a parte decimal a dois dígitos

      // Reconstrução do valor formatado para exibição
      const cleanValue = `${inteiro}${decimal ? ',' + decimal : ''}`;
      console.log('Valor limpo:', cleanValue);

      // Atualiza o valor formatado
      this.formattedValue = this.formatCurrency(cleanValue);

      // Emite o valor sem formatação (apenas números) para o v-model
      const rawValue = parseFloat(`${inteiro}.${decimal || '00'}`);
      console.log('Valor numérico sem formatação:', rawValue);
      this.$emit('input', rawValue); // Emite o valor limpo sem formatação
    }
  }
};
</script>
